import React from 'react'

const Eye = props => (
  // <svg
  //   width={props.width ? props.width : '20'}
  //   height={props.width ? props.width : '16'}
  //   viewBox='0 0 20 16'
  //   fill={props.color ? props.color : '#000000'}
  //   xmlns='http://www.w3.org/2000/svg'
  // >
  //   <path
  //     fillRule='evenodd'
  //     clipRule='evenodd'
  //     d='M10 0C13.5878 0 16.7554 2.43241 19.5113 7.14351L19.7172 7.50112L20 8L19.5113 8.85649C16.7554 13.5676 13.5878 16 10 16C6.41215 16 3.24464 13.5676 0.488744 8.85649L0.282823 8.49888L0 8L0.282823 7.50112C3.08652 2.55556 6.32245 0 10 0ZM10 2C7.29692 2 4.72829 3.91554 2.30532 8C4.72829 12.0845 7.29692 14 10 14C12.6297 14 15.1289 12.1901 17.487 8.34472L17.6948 8.00013L17.4867 7.65533C15.1249 3.80768 12.6259 2 10 2ZM10 5C11.6569 5 13 6.34315 13 8C13 9.65685 11.6569 11 10 11C8.34315 11 7 9.65685 7 8C7 6.34315 8.34315 5 10 5Z'
  //   />
  // </svg>

  <svg
    width={props.width ? props.width : '20'}
    height={props.width ? props.width : '14'}
    viewBox='0 0 20 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M10 4C8.358 4 7 5.359 7 7C7 8.642 8.358 10 10 10C11.641 10 13 8.642 13 7C13 5.359 11.641 4 10 4Z' fill='white' />
    <path
      d='M10 0C2.408 0 0.126318 6.617 0.105431 6.684L0 7L0.104436 7.316C0.126318 7.383 2.408 14 10 14C17.592 14 19.8737 7.383 19.8946 7.316L20 7L19.8956 6.684C19.8737 6.617 17.592 0 10 0ZM10 12C4.67774 12 2.61587 8.154 2.11657 7C2.61786 5.842 4.68072 2 10 2C15.3223 2 17.3841 5.846 17.8834 7C17.3821 8.158 15.3193 12 10 12Z'
      fill='white'
    />
  </svg>
)

export default Eye
